import {ActionHandlerBase} from "../action-handler-base";
import {AreaType, CasinoFreeToPlayGameStage, IOpenCasinoFreeToPlayActionPayload} from "@sparkware/uc-sdk-core";
import {ISendElasticEventOptions} from "../../../analytics/analytics.service.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";

export class OpenCasinoFreeToPlayActionHandler extends ActionHandlerBase<IOpenCasinoFreeToPlayActionPayload> {
    async handle(payload: IOpenCasinoFreeToPlayActionPayload): Promise<void> {
        if(!await this.services.user.ensureUserIsLoggedIn('OpenCasinoFreeToPlayActionHandler')) {
            throw new Error('User is not logged in');
        }

        await this.services.freeToPlay.waitForEligibility();

        if (!this.services.freeToPlay.isPromotionEligible) {
            throw new Error('Free to play is not enabled or user is not eligible!');
        }

        const gameStage = payload.launchInfo?.appSpecificParameters?.gameStage ?? CasinoFreeToPlayGameStage.MiniArena;

        this._sendAnalytics(gameStage);

        await this.services.freeToPlay.showPromotion({
            channel: {
                area: AreaType.externalClick,
                source: CHANNEL_SOURCE.casinoClient,
                element: CHANNEL_ELEMENTS.deepLink,
                ...payload.launchInfo?.channel
            },
            appSpecificParameters: {
                gameStage: gameStage
            }
        });
    }

    private _sendAnalytics(gameStage: CasinoFreeToPlayGameStage) {
        try {
            let options: ISendElasticEventOptions = {
                action: "CLICK",
                category: "Deep_link",
                eventType: "bonus_widget",
                value: gameStage.toString(),
                appID: "F2P",
                customData: {
                    location: this.services.location.isHomePage ? 'homepage' : this.services.location.currentUri.pathName.toString(),
                    segmentation: this.services.user.playerRMSStatus
                }
            };
            this.services.analytics.sendElasticInfoEvent(options, true);
        }
        catch (err){
            console.log("F2P Deep_link analytics report failed with error: "+ err);
        }
    }

}